import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Vehicle Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const VehicleView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="vehicle"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default VehicleView;
